<template>
    <div>
      <!-- Body -->
      <div class="body">
        <div>
          <themed-table 
            :headers="this.bedManagerService.jobs.headers" 
            :data="transformedData" 
            :pagination="{
                perPage: this.bedManagerService.jobs.query.limit,
                total: this.bedManagerService.jobs.total
            }"
            :sorting="{
              type: this.bedManagerService.jobs.query.sortProperty === 'devices.tasks.status' ? 'status' : this.bedManagerService.jobs.query.sortProperty || 'created',
              direction: this.bedManagerService.jobs.query.sortDirection || 'desc'
            }"
            :sortingEnabled=true 
            :filteringEnabled=false
            :paginationEnabled="this.bedManagerService.jobs.total > this.bedManagerService.jobs.query.limit" 
            :tenantSelected="currentTenant"
            @paginationChange="(event) => {
                this.bedManagerService.jobs.query.skip = this.bedManagerService.jobs.query.limit * (event.page - 1);
                this.bedManagerService.jobs.query = {...this.bedManagerService.jobs.query};
            }"
            @searchChange="(event) => {
              const query = this.bedManagerService.jobs.query;
              query.skip = 0; // Resets skip as the search params change
              let newTenant = null;
              Object.keys(event).forEach((key) => {
                const customHandlers = ['scope', 'deviceCount', 'taskType', 'packageId', 'status'];
                if (!customHandlers.includes(key) && event[key]) query[key] = event[key];
                else if (key === 'taskType' && event[key]) query[key] = event[key].reduce((accumulator, item) => {
                    accumulator.push(item.value);
                    return accumulator;
                  }, []);
                else if (key === 'scope' && event[key] && this.bedManagerService.tenants.selected !== event[key]) newTenant = event[key];
                else if (key === 'deviceCount' && event[key]) query['deviceId'] = event[key];
                else if (key === 'packageId' && event[key]) query['packageId'] = event[key].value;
                else if (key === 'status' && Array.isArray(event[key])) { 
                  query['status'] = event[key].reduce((accumulator, item) => {
                    if (item.value === 'queued') {
                      accumulator = [ ...accumulator, 'Queued' ];
                    } else if (item.value === 'progress') {
                      accumulator = [ ...accumulator, 'Queued', 'WaitingForUserAcknowledgement', 'Downloading', 'Staging', 'GatewayUpdating', 'GatewayRebooting', 'In Progress', 'Delivery Success' ];
                    } else if (item.value === 'succeeded') {
                      accumulator = [ ...accumulator, 'Succeeded', 'GatewayUpdateSuccess', 'DeviceUpdateComplete' ];
                    } else if (item.value === 'awaiting') {
                      accumulator = [ ...accumulator, 'WaitingForUserAcknowledgement' ];
                    } else if (item.value === 'error') {
                      accumulator = [ ...accumulator, 'Error', 'Failed', 'Delivery Failed', 'Delivery Rejected', 'Delivery Timed Out' ];
                    } else if (item.value === 'canceled') {
                      accumulator = [ ...accumulator, 'Canceled', 'Delivery Canceled', 'Delivery Removed' ];
                    }
                    return accumulator;
                  }, []);
                }
                else delete query[key];
              })
              if (newTenant !== null) {
                Object.keys(query).forEach((prop) => this.bedManagerService.jobs.query[prop] = query[prop]);
                this.bedManagerService.tenants.selected = newTenant;
                if (!newTenant) {
                  this.bedManagerService.devices.data = [];
                  this.bedManagerService.devices.total = 0;
                  this.bedManagerService.jobs.data = [];
                  this.bedManagerService.jobs.total = 0;
                }
              } else {
                this.bedManagerService.jobs.query = {...query};
              }
            }" 
            @tenantChange="(event) => {
              this.bedManagerService.tenants.selected = event;
              if (!event) {
                this.bedManagerService.devices.data = [];
                  this.bedManagerService.devices.total = 0;
                  this.bedManagerService.jobs.data = [];
                  this.bedManagerService.jobs.total = 0;
              }
            }"
            @sortingChange="(event) => {
              if (event === 'delete') {
                delete this.bedManagerService.jobs.query.sortProperty;
                delete this.bedManagerService.jobs.query.sortDirection;
                this.bedManagerService.jobs.query = { ...this.bedManagerService.jobs.query };
              } else if (event.type === 'status') {
                this.bedManagerService.jobs.query = { ...this.bedManagerService.jobs.query, sortProperty: 'devices.tasks.status', sortDirection: event.direction };
              } else {
                this.bedManagerService.jobs.query = { ...this.bedManagerService.jobs.query, sortProperty: event.type, sortDirection: event.direction };
              }
            }"
            @rowClick="(event) => {
              setJob(event);
            }"
            :addItem="{ label: 'Job', element: CreateJobs }"
            ></themed-table>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Vue from "vue";
  import VueToast from "vue-toast-notification";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import ThemedTable from "../../../shared/careai/components/ThemedTable.vue";
  import BedManagerService from "../BedManager.service";
  import CreateJobs from "./CreateJobs.vue";

  const moment = require("moment");
  
  Vue.use(VueToast);
  Vue.use(Loading);
  Vue.component('themed-table', ThemedTable);
  
  export default {
    name: "Jobs",
    components: { },
    data() {
      return {
        console: console,
        moment: moment,
        // Singleton Pattern Service
        // Contains State and API Requests
        bedManagerService: BedManagerService,
        
        jobInterval: null,

        CreateJobs: CreateJobs,
      };
    },
    computed: {
      transformedData() {
        if (Array.isArray(this.bedManagerService.jobs.data)) {
            this.bedManagerService.jobs.data.forEach((item) => {
                if (item.created) {
                    item.createdFormatted = moment(item.created).format("MMMM Do, YYYY [at] h:mm A");
                }
                if (Array.isArray(item.tasks)) {
                  item.tasksMapped = item.tasks.map((task, index) => {
                    let entry =  `<span><b>Task ${index + 1}</b>: ${task.type}`;
                    entry += '</span>';
                    return entry;
                  });
                  item.tasksFormatted = `<div style="display: flex; flex-direction: column;">${item.tasksMapped.join(' ')}</div>`;
                }
                if (Array.isArray(item.tasks)) {
                  item.tasksPackages = item.tasks.map((task) => {
                    let entry =  `<span><b style="word-break: break-word">${task.metadata.packageLabel}</b>: ${task.metadata.packageVersion}`;
                    entry += '</span>';
                    return entry;
                  });
                  item.tasksPackages = `<div style="display: flex; flex-direction: column;">${item.tasksPackages.join(' ')}</div>`;
                }
                if (Array.isArray(item.devices)) {
                  item.devicesMapped = item.devices.reduce((retVal, device) => {
                    if (Array.isArray(device.tasks)) {
                      device.tasks.forEach((task, index) => {
                        let val = `<span style="display: flex; gap: 5px;"><b>${device.id}:</b> Task ${index + 1}`;
                        if (task.previousVersion && task.selectedVersion) val += ` 
                          <span style="flex:1">
                            (<small><i>${task.previousVersion} -> ${task.selectedVersion}</i></small>)
                          </span>
                        `;
                        if (task.status) val += `<strong style="color: #1dd8f6;">${task.status}</strong>`;
                        val += '</span>';
                        retVal.push(val);
                      })
                    }
                    return retVal;
                  }, []);
                  item.devicesFormatted = `<div style="display: flex; flex-direction: column;">${item.devicesMapped.join(' ')}</div>`;
                  item.deviceCount = item.devices.length;
                  item.statusReduction = item.devices.reduce((accumulator, device) => {
                    if (device && Array.isArray(device.tasks)) {
                      device.tasks.reduce((accumulator, task) => {
                        // Set Status Count Map
                        if (accumulator.statusCounts[task.status + ' ' + (task.errors || '') || 'Queued']) accumulator.statusCounts[task.status + ' ' + (task.errors || '') || 'Queued'] += 1;
                        else accumulator.statusCounts[task.status + ' ' + (task.errors || '') || 'Queued'] = 1;
                        return accumulator;
                      }, accumulator);
                      if (device.tasks.every((task) => ['Succeeded', 'GatewayUpdateSuccess', 'DeviceUpdateComplete'].includes(task.status))) accumulator.completedDevices += 1;
                    }
                    return accumulator;
                  }, {
                    statusCounts: {},
                    completedDevices: 0,
                    totalTasks: item.devices.length * item.tasks.length,
                    totalDevices: item.devices.length,
                  });
                  item.status = `<div style="display: flex; flex-direction: column;">
                    <span style="display: flex; align-items: flex-start; gap: 5px;">
                      <div style="display: flex; flex-direction: column; gap: 5px;">
                        ${Object.keys(item.statusReduction.statusCounts).map((key) =>{
                          return `<small>${item.statusReduction.statusCounts[key]} ${key}</small>`;
                        }).join('')}
                        <hr style='margin: 0;'>
                        <small style="display: flex; gap: 5px;">
                          <div class="${
                            item.statusReduction.completedDevices === item.statusReduction.totalDevices ? 
                              'isReady' : 'isNotReady'
                            }"></div>
                          <b> ${item.statusReduction.completedDevices} / ${item.statusReduction.totalDevices} Completed</b>
                        </small>
                      </div>
                    </span>
                  </div>`;
                  item.lastUpdatedAtReduced = item.devices.reduce((retVal, device) => {
                    if (Array.isArray(device.tasks)) {
                      device.tasks.forEach((task) => {
                        const lastUpdate = new Date(task.lastUpdatedAt);
                        if (retVal.getTime() < lastUpdate.getTime()) retVal = lastUpdate;
                      })
                    }
                    return retVal;
                  }, new Date(item.created));
                  item.lastUpdatedAtReduced = moment(item.lastUpdatedAtReduced).format("MMMM Do, YYYY [at] h:mm A");
                }
            })
        }
        return this.bedManagerService.jobs.data;
      },
      currentQuery() {
        if (this.bedManagerService.jobs.query) {
            return this.bedManagerService.jobs.query;
        }
        return null;
      },
      currentTenant() {
        if (this.bedManagerService.tenants) {
            return this.bedManagerService.tenants.selected;
        }
        return null;
      },
    },
    watch: {
        currentQuery(newQuery, oldQuery) {
          this.bedManagerService.fetchJobs();
        },
        currentTenant() {
          this.bedManagerService.fetchJobs();
        }
    },
    mounted() {
      this.bedManagerService.fetchJobs();
      // Set Jobs & Start Poll
      this.jobInterval = setInterval(() => {
        this.bedManagerService.fetchJobs();
        
        // If a job is selected, on poll this will keep that job up to date
        if (this.bedManagerService.selectedJob && this.bedManagerService.selectedJob.id) {
          const job = this.bedManagerService.jobs && Array.isArray(this.bedManagerService.jobs.data) ? this.bedManagerService.jobs.data.find((item) => item._id === this.bedManagerService.selectedJob.id) : false;
          if (job) {
            this.setJob(job, false);
          }
        }
      }, this.bedManagerService.DEFAULT_POLL_INTERVAL_IN_SECS * 1000);

      // Used as ON DESSTROY
      this.$router.afterEach(() => {
        try {
          clearInterval(this.jobInterval);
        } catch (e) { this.console.log(e); }
      });
    },
    unmounted() {},
    methods: {
      formatSelectedJobData(event) {
        let jobRows = [];
        event.devices.forEach((device) => {
          event.tasks.forEach((task, index) => {
            const taskType = task.type;
            let taskDetails = '';
            if (task.metadata) {
              if (task.metadata.packageId) taskDetails += `<b>ID</b>: ${task.metadata.packageId} `;
              if (task.metadata.packageLabel) taskDetails += `<b>Label</b>: ${task.metadata.packageLabel} `;
              if (task.metadata.packageLabel) taskDetails += `<b>Version</b>: ${task.metadata.packageVersion} `;
            }
            jobRows.push({
              jobId: event._id,
              tenant: event.tenant,
              id: `${device.id}`,
              ipPrefix: 'HARDCODE (TODO)',
              taskIndex: index + 1,
              taskType,
              taskStatus: `
                ${Array.isArray(device.tasks) && device.tasks[index].status ? device.tasks[index].status : 'Unavailable'} 
                ${Array.isArray(device.tasks) && device.tasks[index].errors ? `<small>(${device.tasks[index].errors})</small>` : ''}
              `,
              mac: device.mac,
              taskDetails, 
              lastUpdatedAt: moment(
                (Array.isArray(device.tasks) && device.tasks[index] && device.tasks[index].lastUpdatedAt ? 
                  new Date(device.tasks[index].lastUpdatedAt) : new Date(event.created))
              ).format("MMMM Do, YYYY [at] h:mm A")
            })
          })
        });
        return jobRows;
      },
      setJob(event, doNavigate = true) {
        const jobRows = this.formatSelectedJobData(event);
        this.bedManagerService.selectedJob = { ...this.bedManagerService.selectedJob, data: jobRows, id: event._id };
        if (doNavigate) {
          setTimeout(() => this.bedManagerService.tabIndex = 0, 15);
          setTimeout(() => this.bedManagerService.tabIndex = 3, 25);
        }
      }
    },
  };
  </script>
  
  <!-- Header Styles -->
  <style lang="scss" scoped>
    .page-header {
      &__flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
  
      &__statistics {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
  
      &__statistics-item {
        font-size: .7em;
        display: flex;
        flex-direction: column;
      }
    }

    .body {
        &__inner {
            padding: 15px;
        }
    }
  </style>  
  
  <style>
  ::-webkit-scrollbar {
    width: 6px; 
    height: 6px;
  }</style>
  